import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';

import { media } from '@myrealtrip/modash';
import { IcoMedal } from '@myrealtrip/web-icons';
import { ResponsiveImage, Text } from '@myrealtrip/web-ui';

import Badge from '~components/HighlightBadge';
import Show from '~components/Show';

import type { TransportationProduct } from '~models/Transportation/PointToPointTicket';

interface Props {
  product: TransportationProduct;
}

const Thumbnail = ({ product }: Props) => {
  const { colors } = useTheme();
  const { officialPartner, thumbnailUrls } = product ?? {};

  return (
    <Container>
      <Show when={product.promotion}>
        <HighlightBadge type="promotion" text="프로모션 특가" index={0} />
      </Show>
      <ImageDimmed />
      <Image src={thumbnailUrls ? thumbnailUrls[0] : ''} alt="pass product thumbnail" />
      <Show when={officialPartner}>
        <OfficialDistributor>
          <IcoMedal size={20} color={colors.white} />
          <Text typography="paragraphNormal13" color={colors.white}>
            공식 판매처
          </Text>
        </OfficialDistributor>
      </Show>
    </Container>
  );
};

export default Thumbnail;

const Container = styled.div`
  position: relative;
  height: 160px;
`;

const ImageDimmed = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: inherit;
  z-index: 1;
  background: linear-gradient(
    16deg,
    rgba(0, 0, 0, 0.32) 10.21%,
    rgba(0, 0, 0, 0.04) 32.91%,
    rgba(0, 0, 0, 0) 84.63%
  );
  border-radius: 12px 12px 0 0;
`;

const Image = styled(ResponsiveImage)`
  width: 100%;
  height: inherit;
  border-radius: 12px 12px 0 0;

  ${media.minMobile} {
    width: 520px;
    height: 160px;
  }
`;

const OfficialDistributor = styled.div`
  position: absolute;
  bottom: 10px;
  left: 14px;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 1px;
`;

const HighlightBadge = styled(Badge)<{ index: number }>`
  position: absolute;
  top: -4px;
  left: -7px;
  z-index: 1;
`;
